<app-mu-form-fieldset
  appValidator
  [formGroup]="formData"
  [customClass]="'mu-form-radio-icon-content'"
  [customGridCol]="12"
  [slimPadding]="true"
  [ngClass]="{
    'mu-radio-icon-select': skinIcon,
    'mu-radio-icon-active': value === this.formData.get(controlName)?.value
  }"
>
  <div class="mu-radio-icon" [ngClass]="{ 'mu-field-disabled': !hasPermission && hasPermission !== undefined }">
    <i class="fas {{ icon }}" aria-hidden="true"></i>
    <label *ngIf="!showData">{{ 'form.label.' + label | translate }}</label>
    <label *ngIf="showData"
      ><span class="mu-label-schedule">{{ label }}</span
      >&nbsp;<i class="fas fa-edit" aria-hidden="true"></i
    ></label>
    <p-radioButton type="radio" [value]="value" [id]="controlName" [name]="controlName" [formControlName]="controlName"></p-radioButton>
  </div>
</app-mu-form-fieldset>
